let runtimeConfig: Record<string, unknown>;

export async function loadRuntimeConfig() {
  // In test environment, skip fetching config.json and use environment variables directly
  if (import.meta.env.MODE === 'test' || typeof window === 'undefined') {
    runtimeConfig = { ...import.meta.env };
    return;
  }

  // Check if we're in a development environment (localhost or LocalCan domains)
  const isDevelopment =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('.local') ||
    window.location.hostname.includes('.localcan.dev') ||
    import.meta.env.DEV;

  // For development environments, prefer environment variables but still try config.json as fallback
  if (isDevelopment) {
    try {
      const res = await fetch('/config.json', { cache: 'no-store' });
      if (res.ok) {
        const configData = await res.json();
        // Merge config.json with environment variables, giving precedence to environment variables
        runtimeConfig = { ...configData, ...import.meta.env };
        console.log(
          '✅ Loaded config.json and merged with environment variables',
        );
        return;
      }
    } catch {
      console.log(
        'ℹ️ No config.json found in development, using environment variables',
      );
    }

    // Fallback to environment variables for development
    runtimeConfig = { ...import.meta.env };
    return;
  }

  // For production environments, config.json is required
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (!res.ok)
      throw new Error(
        `Failed to fetch config.json: ${res.status} ${res.statusText}`,
      );
    runtimeConfig = await res.json();
    console.log('✅ Loaded production config.json');
  } catch (error) {
    console.error(
      '❌ Failed to load config.json in production environment:',
      error,
    );
    // In production, we still fallback to environment variables as last resort
    runtimeConfig = { ...import.meta.env };
  }
}

export function getRuntimeConfig() {
  if (!runtimeConfig) throw new Error('Runtime config not loaded yet');
  return runtimeConfig;
}
